import menuItems from "@/helpers/menuItems.js";
import auth from "@/auth.js";
import mutations from "../mutations";
import menuItemsGenDoc from "../../GenDoc/helpers/menuItemsGenDoc.js";
import menuItemsProjects from "../../projects/helpers/menuItemsProjects.js";
import menuItemsCrm from "../../Crm/helpers/menuItemsCrm.js";
import menuItemsSales from "../../sales/helpers/menuItemsSales.js";


const {
  SET_USER,
} = mutations;

export default {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {
    menuItems: ({ user }) => {
      if (user) {
        return menuItems[user.role];
      }
      return [];
    },
    isLoggedIn: ({ user }) => !!user,
    roleName({ user }) {
      if (user) {
        return auth.rolesDict.find(role => user.role === role.value)?.text;
      }
      return "";
    },
    menuItemsGenDoc: ({ user }) => {
      if (user) {
        return menuItemsGenDoc[user.role];
      }
      return [];
    },
    menuItemsProjects: ({ user }) => {
      if (user) {
        return menuItemsProjects[user.role];
      }
      return [];
    },
    menuItemsCrm: ({ user }) => {
      if (user) {
        return menuItemsCrm[user.role];
      }
      return [];
    },
    menuItemsSales: ({ user }) => {
      if (user) {
        return menuItemsSales[user.role];
      }
      return [];
    },
  },
  mutations: {
    [SET_USER](state, user) {
      state.user = user;
    },
  },
  actions: {
    setUser({ commit }, user) {
      commit(SET_USER, user);
    },
    logout({ commit }) {
      auth.logout();
      commit(SET_USER, null);
    },
    login({ commit }) {
      const user = auth.getUser();
      commit(SET_USER, user);
    },
  },
};